import { render, staticRenderFns } from "./addPrinterRule.vue?vue&type=template&id=4bce04dd"
import script from "./addPrinterRule.vue?vue&type=script&lang=js"
export * from "./addPrinterRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports